import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faList, faBolt, faCheck, faUserClock, faMagnet, fatools, faTools } from "@fortawesome/free-solid-svg-icons";
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import React from 'react';

const Header = () => {

  const [currentIcon, setCurrentIcon] = React.useState(0);
  const icons = [
    { icon: "fa-instagram", color: "text-instagram" },
    { icon: "fa-tiktok", color: "text-tiktok" },
    { icon: "fa-youtube", color: "text-danger" },
    { icon: "fa-twitter-x", color: "text-white bg-dark rounded"}
  ];

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIcon((prev) => (prev + 1) % icons.length);
    }, 2000);

    return () => clearInterval(timer);
  }, []);

  return (
    <header className="bg-white py-10">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Title */}
        <h1 className="text-4xl font-bold text-gray-800">
          Grow Your <span className="text-instagram">Followers</span> on <i className={`fa-brands w-10 ${icons[currentIcon].icon} ${icons[currentIcon].color}`}></i> with the Power of <span className="text-instagram">AI</span>
        </h1>
        <p className="mt-4 text-lg text-gray-600">
          <strong>Skyrocket Your Social Presence with Real Followers Delivered Automatically Every Single Day!</strong>
        </p>

        <Container className="d-flex flex-column justify-content-center align-items-center text-center">
          <a href="/register" className="min-w-[300px] py-3 my-2 pop-button items-center text-lg font-bold bg-instagram text-white rounded px-3 text-decoration-none">Start Gaining Followers <i className="fa-solid fa-arrow-right ms-2"></i></a>
          <a href="#visualizer">
            <div className="btn min-w-[300px] border-instagram" style={{borderWidth: '2px'}} variant="instagram">
              <strong>Preview Your Growth <i className="fa-solid fa-chart-line ms-2"></i></strong>
            </div>
          </a>
        </Container>
		<div class="tech-slideshow mt-3 d-none">
				<div class="mover-1">
				  <span>🚀 Boost Your Reach |</span>
				  <span>📊 Track Your Growth |</span>
				  <span>📈 Build Social Proof |</span>
				  <span>✨ Spark Authentic Engagement |</span>
				  <span>🌍 Expand Your Audience |</span>
				  <span>🔥 Go Viral Fast |</span>
				  <span>💼 Enhance Professional Image |</span>

				  <span>🚀 Boost Your Reach |</span>
				  <span>📊 Track Your Growth |</span>
				  <span>📈 Build Social Proof |</span>
				  <span>✨ Spark Authentic Engagement |</span>
				  <span>🌍 Expand Your Audience |</span>
				  <span>🔥 Go Viral Fast |</span>
				  <span>💼 Enhance Professional Image |</span>

				  <span>🚀 Boost Your Reach |</span>
				  <span>📊 Track Your Growth |</span>
				  <span>📈 Build Social Proof |</span>
				  <span>✨ Spark Authentic Engagement |</span>
				  <span>🌍 Expand Your Audience |</span>			  
				  <span>🔥 Go Viral Fast |</span>
				  <span>💼 Enhance Professional Image |</span>

				  <span>🚀 Boost Your Reach |</span>
				  <span>📊 Track Your Growth |</span>
				  <span>📈 Build Social Proof |</span>
				  <span>✨ Spark Authentic Engagement |</span>
				  <span>🌍 Expand Your Audience |</span>
				  <span>🔥 Go Viral Fast |</span>
				  <span>💼 Enhance Professional Image |</span>

				</div>
			  </div>

        {/* Cards */}
        <div className="mx-auto max-w-screen-md grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 justify-content-center align-items-center text-center">
          {/* Scanner Tool Card */}
          <div className="bg-white shadow-lg rounded-lg p-6 border-instagram">
            <div className="flex items-center justify-center text-instagram">
			  <i className="fa-solid fa-magnet text-instagram h1" />
            </div>
            <span className="text-xl text-instagram font-bold mt-4">Automated Follower Delivery</span>
            <p className="text-gray-600 text-lg font-medium mt-1">
              <span className="font-extrabold text-black">New Followers</span> Added Daily
            </p>
			<hr className="bg-instagram" />
			<ul className="text-left space-y-2 text-gray-700">
			  <li className="flex items-center">
			    <i className="fa-solid fa-chart-line text-instagram w-10" />
			    <span>Just Purchase & Watch Followers Grow</span>
              </li>
			  <li className="flex items-center">
			    <i className="fa-solid fa-robot text-instagram w-10" />
			    <span>No Action Required From You</span>
              </li>
			  <li className="flex items-center">
			    <i className="fa-solid fa-shield text-instagram w-10" />
			    <span>100% Safe & Within Guidelines</span>
              </li>
			  <li className="flex items-center">
			    <i className={`fa-brands ${icons[currentIcon].icon} text-instagram w-10`} />
			    <span>Works on All Major Platforms</span>
              </li>
			  <li className="flex items-center">
			    <i className="fa-solid fa-gauge-high text-instagram w-10" />
			    <span>First Followers Added Within 24 Hours</span>
			  </li>
            </ul>
			<a href="#pricing">
				<button className="rounded mt-3 bg-instagram-2 text-white font-medium px-4 py-2 shadow hover:opacity-90">
				Start Automatic Growth Today
				</button>
			</a>
          </div>
		  
		  <div className="bg-white shadow-lg rounded-lg p-6 border-instagram">
            <div className="flex items-center justify-center text-instagram">
			  <i className="fa-solid fa-wand-magic-sparkles text-instagram h1" />
            </div>
            <span className="text-xl text-instagram font-bold mt-4">Growth Accelerator Tools</span>
            <p className="roundedtext-gray-600 text-lg font-medium mt-1">
              <span className="font-extrabold text-black">AI Tools</span> To Supercharge Your Growth
            </p>
			<hr className="bg-instagram" />
			<ul className="text-left space-y-2 text-gray-700">
              <li>
			 		 <i className="fa-solid fa-brain text-instagram w-10" />
			        AI Content Generator
              </li>
			  <li>
			 		 <i className="fa-solid fa-chart-simple text-instagram w-10" />
			        Competitor Analysis Tools  
              </li>
			  <li>
			 		 <i className="fa-solid fa-hashtag text-instagram w-10" />
			        Trending Hashtag Finder
              </li>
			  <li>
			 		 <i className="fa-solid fa-user-secret text-instagram w-10" />
			        Anonymous Story Viewer
              </li>
			  <li>
			 		 <i className="fa-solid fa-video text-instagram w-10" />
			        4K Post Downloader
			  </li>
			  <li>
			 		 <i className="fa-solid fa-magnifying-glass-chart text-instagram w-10" />
			        Advanced Analytics Dashboard
              </li>
            </ul>
			<a href="#pricing">
            <button className="rounded mt-3 bg-instagram-2 text-white font-medium px-4 py-2 rounded-lg shadow hover:opacity-90">
              Get Access Now
            </button>
			</a>
          </div>

          {/* List Builder Card */}
          
		  
        </div>
      </div>
	
    </header>

	
  );
};

export default Header;
